// @flow
import formatters from 'lib/formatters'
import React from 'react'
import Row from './Row'
import styles from './styles'

type Props = {
  closeDate: string,
  openDate: string,
  status: string,
  updatedAt: string,
  userRoles: Array<string>,
  showAccountStatusDialog: Function,
}

const GPTDatesRef = (props: Props) => {
  const { closeDate, openDate, status, updatedAt, userRoles, showAccountStatusDialog } = props

  const hasAvailableStatusOptions = () => {
    if (!status) return false

    const isStatusAdmin = userRoles && userRoles.includes('status_admin')

    if (status === 'approved') {
      return true
    } else if (status === 'suspended') {
      return true
    } else if (status === 'closing' && isStatusAdmin) {
      return true
    } else if (status === 'closed' && isStatusAdmin) {
      return true
    }

    return false
  }

  let dateTitle
  let dateStyle
  let dateInformation
  let showEdit = false

  switch (status) {
    case 'closed':
      dateTitle = 'Closed'
      dateStyle = styles.dateStyleClosed
      dateInformation = styles.dateInfoClosed
      showEdit = hasAvailableStatusOptions()
      break
    case 'closing':
      dateTitle = 'Closing'
      dateStyle = styles.dateStyleClosing
      dateInformation = styles.dateInfoClosing
      showEdit = hasAvailableStatusOptions()
      break
    case 'rejected':
      dateTitle = 'Rejected'
      dateStyle = styles.dateStyleClosed
      dateInformation = styles.dateInfoClosed
      break
    case 'suspended':
      dateTitle = 'Suspended'
      dateStyle = styles.dateStyleSuspended
      dateInformation = styles.dateInfoClosing
      showEdit = hasAvailableStatusOptions()
      break
    case 'pending':
      dateTitle = 'Pending'
      dateStyle = styles.dateStylePending
      dateInformation = styles.dateInfoPending
      break
    case 'active':
    case 'approved':
      dateTitle = 'Active'
      dateStyle = styles.dateStyleActive
      dateInformation = styles.dateInfoOpen
      showEdit = hasAvailableStatusOptions()
      break
  }

  let closed, opened, updated

  if (updatedAt) {
    updated = (
      <div className={styles.lastUpdated}>
        <Row label="Last Update:" val={formatters.lastUpdate(updatedAt)} />
      </div>
    )
  }

  closed = <Row label="Close Date" val={formatters.date(closeDate)} />

  opened = <Row label="Open Date" val={formatters.date(openDate)} />

  return (
    <div className={dateStyle}>
      <div className={styles.flexRow}>
        <div className={styles.accountInfo}>
          <h5>Account Information</h5>
          {updated}
        </div>
        <div className={styles.dateTitle}>
          {dateTitle}
          {showEdit && <a title="Change account status" className={styles.refEditSmall} onClick={() => showAccountStatusDialog()} />}
        </div>
      </div>
      <div className={dateInformation}>
        {opened}
        {closed}
      </div>
    </div>
  )
}

export default GPTDatesRef
